// extracted by mini-css-extract-plugin
module.exports = {"faq":"_2qOMR"};